class CodeageAIChatForm extends HTMLElement {
    constructor() {
        super();
        this.messages = [];
        this.messagesContainer = this.querySelector('[data-messages-container]');
        this.messageInput = this.querySelector('[data-message-input]');
        this.messageSubmit = this.querySelector('[data-message-submit]')
        this.errorContainer = this.querySelector('[data-message-error-container]')
        this.suggestions = this.querySelectorAll('[data-suggestions]');
        this.suggestionsContainer = this.querySelector('[data-suggestions-container]');
        this.locale = window.theme.locale || 'en'
        this.sessionID = '';
        this.sessionIDCookieName = "codeage-api-sessionID";
        this.messageRoles = CODEAGEAICONST.messageRoles;

        this.metaData = {
            product_title: this.dataset.productTitle || "",
        }

        this.messageStatus = CODEAGEAICONST.messageStatus;
        this.abortController = new AbortController();


        this.init();
    }

    init(){
        this.setSessionID(this.getSessionID());
        this.getMessageHistory();
        this.messageSubmit.addEventListener('click', this.onSubmit.bind(this));
        this.messageInput.form.addEventListener('submit', this.onSubmit.bind(this));

        this.suggestions.forEach((suggestion) => {
            suggestion.addEventListener('click', this.clickSuggestions.bind(this));
        })

        //add event listener for global message
        document.addEventListener(CODEAGEAICONST.events.CHAT_ADD, this.handleAddChatMessage.bind(this));
    }

    //event handler for codageai.chat.add
    handleAddChatMessage(event) {
        const { content, role } = event.detail; 
        
        console.log('add chat message');

        if (content && role) {
            const messageElement = this.createChatMessageTemplate(content, role, this.messageStatus.SENT);
            this.renderChatMessage(messageElement);
        } else {
            console.log('missing message content')
        }
        
    }

    clickSuggestions(event){
        let content = event.target.textContent;
        console.log(content);
        this.sendMessage(content);
    }

    hideSuggestions(){
        this.suggestionsContainer.style.display = "none";
    }

    onSubmit(event){
        event.preventDefault();
        
        console.log('submit');
        const input = this.messageInput.value
        if(input || input != ""){
            this.sendMessage(input)
            this.clearMessageInput();
        }
    }

    clearMessageInput(){
        this.messageInput.value = "";
    }

    getSessionID() {
        return Cookies.get(this.sessionIDCookieName);
    }

    setSessionID(sessionID){

        Cookies.set(this.sessionIDCookieName, sessionID, 1)
        this.sessionID = sessionID;
    }

    getMessageHistory() {
        const url = window.theme.apiUrl + '/api/chat/history';

        fetch(`${url}?sessionID=${encodeURIComponent(this.sessionID)}`, {
            signal: this.abortController.signal,
            credentials: 'include'
        })
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }

            return response.json();
        })
        .then((messages) => {
            console.log(messages);
            this.messages = messages;
            this.renderAllChatMessages();
        })
        .catch((error) => {
            console.log(error);
            if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
            }
            throw error;
        });
    
    }

    renderAllChatMessages(){
        const messages = this.messages;

        messages.forEach(({ role, content }) => {
            const messageElement = this.createChatMessageTemplate(content, role, this.messageStatus.SENT);
            this.renderChatMessage(messageElement);
        })

        
    }

    renderChatMessage(messageElement){
        this.messagesContainer.appendChild(messageElement);

        this.scrollBottom();
        //hide suggestions
        this.hideSuggestions();
    }

    setTemplateStatus(messageElement, status){
        const messageStatusClasses = {
            SENDING: 'sending',
            ERROR: 'error'
        }

        //reset template status
        messageElement.classList.remove(messageStatusClasses.SENDING, messageStatusClasses.ERROR)

        console.log('status', status)

        //change template status to sending, sent, error
        if(status == this.messageStatus.SENDING){
            messageElement.classList.add(messageStatusClasses.SENDING);
        }else if(status == this.messageStatus.SENT){
            messageElement.classList.remove(messageStatusClasses.SENDING)
        }else if(status == this.messageStatus.ERROR){
            messageElement.classList.add(messageStatusClasses.ERROR)
        }

        

        return messageElement
    }

    createChatMessageTemplate(content, role, status){
        let messageElement = document.createElement('div');

        content = this.formatText(content);
        let innerContent = `<div>${content}</div>`;
        let classes = ['chat-message-container']
        
        if(role == this.messageRoles.AI){
            classes.push('assistant-chat');
        }else if(role == this.messageRoles.HUMAN){
            classes.push('user-chat');
            if(status == this.messageStatus.SENDING){
                innerContent += `<span class="sending-text-notification">${window.theme.strings.product_chat_bot.sending_chat_notification}</span>`
            }
        }
        
        messageElement.classList.add(...classes);
        messageElement.innerHTML = innerContent;

        this.messages.push({
            content,
            role
        })

        return messageElement;
    }

    formatText(text){
        //replace newlines with br
        text = text.trim();
        return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }


    sendMessage(message){

        const url = window.theme.apiUrl + '/api/chat';

        //disable submit button
        this.messageSubmit.disabled = true;

        message = message.trim();

        this.sessionID = this.getSessionID();

 
        let data = {
            message,
            locale: window.theme.locale || "us",
            sessionID: this.sessionID,
            ...this.metaData
        }
       

        //hide error
        this.hideError();

        //add user message
        let userResponseTemplate = this.createChatMessageTemplate(message, this.messageRoles.HUMAN, this.messageStatus.SENDING);
        userResponseTemplate = this.setTemplateStatus(userResponseTemplate, this.messageStatus.SENDING);
        this.renderChatMessage(userResponseTemplate);

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        })
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }

            return response.json();
        })
        .then((response) => {
            console.log(response);
            let answer = response.answer;
            
            let adminResponseTemplate = this.createChatMessageTemplate(answer, this.messageRoles.AI, this.messageStatus.SENT);
            this.renderChatMessage(adminResponseTemplate);
            
            this.setTemplateStatus(userResponseTemplate, this.messageStatus.SENT);

            if(this.sessionID == "" || !this.sessionID && response.sessionID){
                this.setSessionID(response.sessionID);
            }

            //hide suggestions
            this.hideSuggestions();
        })
        .catch((error) => {
            console.log(error);

            this.setTemplateStatus(userResponseTemplate, this.messageStatus.ERROR);
            this.showError("Error has occured. Unable to send your message.");

            if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
            }
            throw error;
        })
        .finally(() => {
            //re enable submit button
            this.messageSubmit.disabled = false;
        })

        
    }

    getAdminResponseTemplate(text){
        return `<div class="chat-message-container assistant-chat">
            <div class="">${text}</div>
          </div>`
    }
    
    getUserChatTemplate(text, status){
        return `<div class="chat-message-container user-chat">
            <div class="">${text}</div>
            ${status == this.status.SENDING? `<span class="sending-text-notification">${window.theme.strings.product_chat_bot.sending_chat_notification}</span>` : '' }
        </div>`;
    }

    hideError(){
        this.errorContainer.style.display = "none"
    }

    showError(error){
        this.errorContainer.textContent = error;
        this.errorContainer.style.display = "block"
    }

    scrollBottom() {
    	 this.messagesContainer.scrollTo(0, this.messagesContainer.scrollHeight)
    }
}

customElements.define('codeage-ai-chat-form', CodeageAIChatForm);